import React, { Suspense } from 'react';
import { DeferredRender } from '../DeferredRender';
import styles from '../../utils/styles/components/Section/style.module.css';

export const Section = ({
  id,
  eyebrow,
  title,
  description,
  children,
  deferBody = false,
  deferredFallback = null,
  deferredMinHeight = 0,
  deferredRootMargin
}) => {
  const bodyContent = deferBody ? (
    <DeferredRender
      fallback={deferredFallback}
      minHeight={deferredMinHeight}
      rootMargin={deferredRootMargin}
    >
      <Suspense fallback={deferredFallback}>{children}</Suspense>
    </DeferredRender>
  ) : (
    children
  );

  return (
    <section className={styles.section} id={id}>
      <div className={styles.header}>
        <span className={styles.eyebrow}>{eyebrow}</span>
        <h2 className={styles.title}>{title}</h2>
        {description ? <p className={styles.description}>{description}</p> : null}
      </div>
      <div className={styles.body}>{bodyContent}</div>
    </section>
  );
};
